import { AntDesign } from "@expo/vector-icons";
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Text,
  View,
  StyleSheet,
  SafeAreaView,
  ImageBackground,
  ScrollView,
  TouchableOpacity,
  RefreshControl,
} from "react-native";
import Queries from "../../api/queries";
import RootStore from "../../Store";
import Colors from "../../Theme/Colors";
import typo from "../../Theme/Typo";

import { Calendar, LocaleConfig } from "react-native-calendars";
import { format, subMonths, addMonths } from "date-fns";
import { fr } from "date-fns/locale";
import { BookingCalendar } from "../../api/type/type";
import LoadingModal from "../LoadingModal";
import ModalQLerr from "../../utils/ModalQLerr";
import { formatDateHour } from "../../utils/dateFormater";

const BG_PATH = require("../../../assets/newDesign/background-portrait.png");

LocaleConfig.locales["fr"] = {
  monthNames: [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ],
  monthNamesShort: [
    "Janv.",
    "Févr.",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juil.",
    "Août",
    "Sept.",
    "Oct.",
    "Nov.",
    "Déc.",
  ],
  dayNames: [
    "Dimanche",
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
  ],
  dayNamesShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."],
  today: "Aujourd'hui",
};
LocaleConfig.defaultLocale = "fr";

interface BookingType {
  arrivalDate: string;
  departureDate: string;
  checkIn: string;
  checkOut: string;
  appartName: string;
  firstName: string;
  lastName: string;
}

const { userInfo } = RootStore?.getInstance();

const HomePresta = ({ navigation }) => {
  // calendar
  const { t, i18n } = useTranslation();
  const queries = new Queries();
  const [dateSelected, setDateSelected] = useState<Date>(new Date());
  const [detailDaySelected, setDetailDaySelected] = useState({
    nbCheckIn: 0,
    nbCheckOut: 0,
    resa: [],
  });

  const [QLerror, setQLerror] = useState("");

  const [isRefreshingBooking, setRefreshBooking] = useState<boolean>(false);

  const [bookings, setBookings] = useState<Array<BookingType>>([]);
  const [events, setEvents] = useState<any>({});
  const [month, setMonth] = useState<any>(new Date());
  const [isLoading, setLoading] = useState<boolean>(false);

  const getCalendar = async () => {
    setLoading(true);
    try {
      const responseGraphql = await queries.getBookingCalendar(month);

      let errors = responseGraphql?.errors;

      if (errors && errors.length > 0) {
        const errorMessage: string = errors[0].message;

        setQLerror(errorMessage);
      } else {
        const { allBooking, events }: BookingCalendar =
          responseGraphql.data.getBookingCalendar;
        setBookings(allBooking);
        getReservation(allBooking);
        eventMaker(events);
      }
    } catch (err) {
      setQLerror(err);
    } finally {
      setLoading(false);
    }
  };

  const eventMaker = (events) => {
    let event = {};

    events.forEach((element) => {
      event[element.date] = {
        periods: element.period,
      };
    });
    setEvents(event);
  };

  useEffect(() => {
    getCalendar();
  }, [month]);

  useEffect(() => {
    getReservation(bookings);
  }, [dateSelected]);

  const getReservation = (bookingsRef) => {
    let nbCheckIn = 0;
    let nbCheckOut = 0;
    const dateFormat = format(dateSelected, "yyyy-MM-dd");
    const newDetail = bookingsRef.filter((element) => {
      const startResa = new Date(element.arrivalDate);
      const endResa = new Date(element.departureDate);
      if (element.arrivalDate == dateFormat) {
        nbCheckIn++;
      }
      if (element.departureDate == dateFormat) {
        nbCheckOut++;
      }
      if (
        startResa.getTime() <= dateSelected.getTime() &&
        dateSelected.getTime() <= endResa.getTime()
      ) {
        return true;
      }
      return false;
    });
    newDetail.sort(
      (a, b) =>
        new Date(`${a.departureDate}T${a.checkOut}`) >
        new Date(`${b.departureDate}T${b.checkOut}`)
    );
    setDetailDaySelected({
      nbCheckIn,
      nbCheckOut,
      resa: newDetail,
    });
  };

  const markedDateSelected = () => {
    const date = format(dateSelected, "yyyy-MM-dd");
    const data = {};

    for (const [key, value] of Object.entries(events)) {
      if (key == date) {
        data[key] = {
          ...value,
          selected: true,
          selectedColor: Colors.oiqia,
        };
      } else {
        data[key] = value;
      }
    }

    if (!data[`${date}`]) {
      data[`${date}`] = {
        selected: true,
        marked: true,
        selectedColor: Colors.oiqia,
      };
    }

    return data;
  };

  const handlerSetDate = (newDate: Date) => {
    const currentMonth = dateSelected.getMonth();
    const newMonths = newDate.getMonth();
    if (currentMonth != newMonths && month.getMonth() != newDate.getMonth()) {
      const newMonth =
        newMonths - currentMonth == -1
          ? subMonths(month, 1)
          : addMonths(month, 1);
      setMonth(newMonth);
    } else if (month.getMonth() != newMonths) {
      const newMonth =
        newMonths - month.getMonth() == -1
          ? subMonths(month, 1)
          : addMonths(month, 1);
      setMonth(newMonth);
    }
    setDateSelected(newDate);
  };

  const handlerChangeMonth = (add: boolean) => {
    const newMonth = add ? addMonths(month, 1) : subMonths(month, 1);
    setMonth(newMonth);
  };

  const FindStatus = ({ booking }) => {
    if (booking) {
      const startResa = new Date(booking.arrivalDate);
      const endResa = new Date(booking.departureDate);
      const currentDate = new Date();

      /*  export const enum bookingStatus {
                 FormIdentity = 5,
                 Entry = 10,
                 CheckIn = 20,
                 CheckOut = 30,
                 Incident = 40
             } */

      // Refers to last booking step value
      let travellerDidEntry = false;
      // if booking step exists
      if (booking?.bookingStep.length > 0) {
        for (let step of booking.bookingStep) {
          if (step.status == 10) {
            travellerDidEntry = true;
          }
        }
      }

      // si le voyageur est entré dans la propriété
      if (travellerDidEntry) {
        // résa en cours
        if (
          startResa.getTime() <= currentDate.getTime() &&
          endResa.getTime() >= currentDate.getTime()
        ) {
          return (
            <Text style={{ fontWeight: "bold", color: "green" }}>
              <AntDesign name="hourglass" size={24} />
              {t("HOME_ONGOING")}
              {/* Voyageur Présent */}
            </Text>
          );
          // résa finie
        } else if (endResa.getTime() <= currentDate.getTime()) {
          return (
            <Text style={{ color: "orange" }}>
              <AntDesign name="hourglass" size={24} />
              {t("HOME_LEAVE")}
              {/* Départ du voyageur aujourd'hui */}
            </Text>
          );
          // résa non commencé -> cas théoriquement impossible
        } else {
          return <Text>Etat inconnu</Text>;
        }
        // le voyageur n'est pas rentré
      } else {
        if (
          startResa.getFullYear() == currentDate.getFullYear() &&
          startResa.getMonth() == currentDate.getMonth() &&
          startResa.getDate() == currentDate.getDate()
        ) {
          return (
            <Text style={{ color: "orange" }}>
              <AntDesign name="hourglass" size={24} />
              {t("HOME_INCOMING")}
              {/* Le voyageur arrive */}
            </Text>
          );
        } else {
          return (
            <Text style={{ color: "red" }}>
              <AntDesign name="hourglass" size={24} />
              {t("HOME_NO_CHECKIN")}
              {/* Le voyageur ne s'est pas présenté */}
            </Text>
          );
        }
      }
    } else {
      return <Text>Etat inconnu</Text>;
    }
  };

  return (
    <SafeAreaView style={typo.mainBackground}>
      <ScrollView
        refreshControl={
          <RefreshControl
            refreshing={isRefreshingBooking}
            onRefresh={() => {
              getCalendar().finally(() => setRefreshBooking(false));
            }}
          />
        }
      >
        {isLoading && <LoadingModal loading={isLoading || isLoading} />}

        {QLerror && QLerror !== "" ? (
          <ModalQLerr reason={QLerror} resetErr={() => setQLerror("")} />
        ) : null}

        <Calendar
          day={dateSelected}
          firstDay={1}
          markingType="multi-period"
          onDayPress={(day) => {
            handlerSetDate(new Date(day.dateString));
          }}
          markedDates={{
            ...markedDateSelected(),
          }}
          onPressArrowLeft={(change) => {
            handlerChangeMonth(false);
            change();
          }}
          onPressArrowRight={(change) => {
            handlerChangeMonth(true);
            change();
          }}
          renderArrow={(direction) => {
            if (direction == "left") {
              return (
                <AntDesign name="arrowleft" size={24} color={Colors.oiqia} />
              );
            } else {
              return (
                <AntDesign name="arrowright" size={24} color={Colors.oiqia} />
              );
            }
          }}
        />
        {detailDaySelected && (
          <View style={{ margin: 10 }}>
            <ImageBackground source={BG_PATH} style={typo.background}>
              <View style={typo.container}>
                <Text style={typo.titleInfo}>
                  {format(dateSelected, "dd MMMM yyyy", { locale: fr })}
                </Text>
                {/*t("HOME_TITLE_SCREEN")*/}
                <View style={typo.resCard}>
                  <View style={style.column}>
                    <View style={style.dateInfo}>
                      <View style={style.underline}>
                        <Text style={typo.h3}>{t("HOME_CHECKIN")}</Text>
                      </View>
                      <Text style={typo.body}>
                        {detailDaySelected.nbCheckIn}
                      </Text>
                    </View>
                    <View style={style.dateInfo}>
                      <View style={style.underline}>
                        <Text style={typo.h3}>{t("HOME_CHECKOUT")}</Text>
                      </View>
                      <Text style={typo.body}>
                        {detailDaySelected.nbCheckOut}
                      </Text>
                    </View>
                  </View>
                </View>
                <View style={typo.resCard}>
                  <Text style={[typo.category, { marginBottom: 10 }]}>
                    {t("HOME_ONGOING_TITLE")} |{" "}
                    <Text style={{ color: Colors.oiqia }}>
                      {detailDaySelected.resa.length}
                    </Text>
                  </Text>
                  <ScrollView>
                    {detailDaySelected.resa.length > 0 ? (
                      detailDaySelected.resa.map((element, index) => (
                        <TouchableOpacity
                          key={index}
                          onPress={() =>
                            navigation.navigate("details", {
                              bookingId: element.bookingId,
                            })
                          }
                        >
                          <View
                            style={{
                              borderColor: "grey",
                              borderWidth: 1,
                              margin: 0,
                              marginBottom: 15,
                              padding: 5,
                              borderRadius: 10,
                            }}
                          >
                            <View
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <Text style={[typo.body, { marginBottom: 5 }]}>
                                <AntDesign
                                  name="home"
                                  size={24}
                                  color={Colors.oiqia}
                                />
                              </Text>
                              <View
                                style={[
                                  style.colorLegend,
                                  { backgroundColor: element.lineColor },
                                ]}
                                children={undefined}
                              ></View>
                              <Text style={{ fontFamily: "RobotoBold" }}>
                                {element.appartName}
                              </Text>
                            </View>
                            <Text style={[typo.body, { marginBottom: 5 }]}>
                              <AntDesign
                                name="user"
                                size={24}
                                color={Colors.oiqia}
                              />{" "}
                              {element.firstName + " " + element.lastName}
                            </Text>
                            <Text style={[typo.body, { marginBottom: 5 }]}>
                              <AntDesign
                                name="calendar"
                                size={24}
                                color={Colors.oiqia}
                              />{" "}
                              <Text style={style.newDate}>
                                {formatDateHour(`${element?.arrivalDate}T${element?.checkIn}`)} →{' '}
                                {formatDateHour(`${element?.departureDate}T${element?.checkOut}`)}
                              </Text>
                            </Text>
                            <Text style={[typo.body, { marginBottom: 5 }]}>
                              <FindStatus booking={element} />
                            </Text>
                          </View>
                        </TouchableOpacity>
                      ))
                    ) : (
                      <Text style={typo.body}>{t("HOME_EMPTY")}</Text>
                    )}
                  </ScrollView>
                </View>
              </View>
            </ImageBackground>
          </View>
        )}
      </ScrollView>
    </SafeAreaView>
  );
};

const style = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: "flex-end",
  },
  newDate: {
    fontWeight: "bold",
    textAlignVertical: "center",
  },
  titleWelcome: {
    fontSize: 18,
    color: "black",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "RobotoMedium",
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
  column: {
    flex: 1,
    alignSelf: "auto",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  dateInfo: {
    width: "50%",
    padding: 5,
    textAlign: "left",

    justifyContent: "flex-start",
  },
  underline: {
    borderColor: "#0A0A0AE7",
    borderBottomWidth: 0.5,
    paddingBottom: 5,
    marginBottom: 10,
  },
  colorLegend: {
    marginStart: 5,
    marginEnd: 5,
    borderRadius: 2,
    width: 30,
    height: 15,
  },
});

export default observer(HomePresta);
